import Duck from "redux-ducks-ts"

export const userBackoffice = new Duck("userBackoffice", "cargo")
